import React from "react";
import {connect} from "dva";
import {component_tool,framework_tool} from '../../../tool';
import {reduxTemplateConfig, templateConfig} from './config';

import mockData from './mock'
import exportColumn from "./exportExamUserAnswers";


let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;
let { WizBrowserExport } = component_tool;

function getTableData(data) {
  let dataInfo = []
  dataInfo = [...data.personIdentitiesInfos]
  let subjects = data.subjects
  let users = data.users

  let disabledEnum = {0: '激活',1: '禁用'}
  let userTypeEnum = {0: '培训平台用户',  3: 'OEM部门用户',4:'经销商用户',5:'服务商用户'}
  let jobStateEnum = {0: '无效',1:'有效'}
  let resultEnum = {0: '错误', 1: '正确', 2: '未答题'}
  dataInfo && dataInfo.forEach(d => {
    d['disabled'] = disabledEnum[d['disabled']]
    d['userType'] = userTypeEnum[d['userType']]
    d['jobState'] = jobStateEnum[d['jobState']]

    users && users.forEach(u => {
      if (d.personId == u.userId) {
        u.answers && u.answers.forEach(a => {
          subjects && subjects.forEach(s => {
            if (s.id == a.subjectId) {
              d['brand_'+s.id] = s.brand
              d['carMode_'+s.id] = s.carMode
              d['title_'+s.id] = s.title
              d['result_'+s.id] = resultEnum[a.result]
              d['timeSpend_'+s.id] = a.timeSpend
            }
          })
        })
      }
    })
  })
  return dataInfo
}

class CleExamManager extends WizContainer {
  componentName = 'CleExamManager';

  constructor(props) {
    super(props);
    this.state={}
  }

  _handleStudentsAnswersFile(nextProps, nextState, key) {
    let o = nextProps[key];
    if (o['success']) {
      let data = o['data']
      let columnDefs = exportColumn(this, data)
      let dataInfo = getTableData(data)
      let title = '考试名称：' + data.title + '\n'
        + '考试时间：' + data.startDate+' ~ ' + data.endDate + '\n'
        + '考试总人数：' + data.userTotal + '\n'
        + '缺考人数：' + data.missUserTotal + '\n'
        + '出卷老师：' + data.teacher
      WizBrowserExport({
        title: title,
        sheetName: '学员答题情况',
        columns: columnDefs.filter((_, index) => index),
        rows: dataInfo,
        filename: '学员答题情况.xlsx',
        titleParams: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true },
          style: {
            alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
          },
          font: {},
        },
        titleRow: {
          height: 70
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _render() {
    let _templateConfig = templateConfig(this)
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        export:this._handleFile,
        exportStudentsAnswers: this._handleStudentsAnswersFile
      },
    });

    return (
      <WizReduxTemplate {..._reduxTemplateConfig} />
    );
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key];

    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '考试名称',
        field: 'title',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '车联试卷编号',
        field: 'cleId',
        width: 50,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '开始时间',
        field: 'startDate',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '结束时间',
        field: 'endDate',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '状态',
        field: 'stateName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
    ]
    let stateEnum = {0: '草稿', 1: '已发布', 2: '已结束', 3: '已关闭'}

    if (o['success']) {
      let data = o['data']
      data.forEach((val, index) => {
        val['stateName'] = stateEnum[val.state]
      })

      WizBrowserExport({
        title: '车联考试',
        sheetName: '车联考试',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '车联考试.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
}
const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(CleExamManager);
